import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Check, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { useState } from "react";

const plans = [
  {
    id: "pro", name: "FULL ACCESS", price: 19,
    desc: "One-off payment. Full network access.",
    features: ["Structured Player Profile", "Public Profile Page", "Listed in Network Directory", "Reviewed by Verified Scouts", "Shareable Profile Link", "Video Highlights", "Unlimited Media"],
    highlight: true,
  },
];

export default function Pricing() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(null);

  const handleSelect = async (planId) => {
    if (!user || user === false) {
      navigate("/start");
      return;
    }
    if (user.plan) {
      toast.info("You already have an active plan.");
      navigate("/dashboard");
      return;
    }
    setLoading(planId);
    try {
      const origin = window.location.origin;
      const { data } = await api.post("/payments/create-checkout", { plan: planId, origin_url: origin });
      if (data.url) window.location.href = data.url;
    } catch {
      toast.error("Payment initiation failed.");
    }
    setLoading(null);
  };

  return (
    <div className="bg-[#0A0A0A] min-h-screen py-24" data-testid="pricing-page">
      <div className="max-w-3xl mx-auto px-4">
        <div className="text-center mb-14">
          <div className="overline mb-3">PRICING</div>
          <h1 className="text-4xl sm:text-5xl font-black tracking-tighter uppercase text-[#F5F5F5] mb-3">
            SIMPLE PRICING
          </h1>
          <p className="text-[#A3A3A3] max-w-md mx-auto">One-off payment. No subscription.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {plans.map((plan) => (
            <div
              key={plan.id}
              className={`p-8 border ${plan.highlight ? "border-[#D4AF37] bg-[#141414] relative" : "border-[#262626] bg-[#0E0E0E]"}`}
              data-testid={`plan-${plan.id}`}
            >
              {plan.highlight && <div className="absolute -top-px left-0 right-0 h-[2px] bg-[#D4AF37]" />}
              <div className="overline mb-2">{plan.name}</div>
              <div className="flex items-baseline gap-1 mb-3">
                <span className="text-4xl font-black text-[#F5F5F5]">${plan.price}</span>
                <span className="text-[#A3A3A3] text-xs"> one-off</span>
              </div>
              <p className="text-sm text-[#A3A3A3] mb-6">{plan.desc}</p>
              <ul className="space-y-2.5 mb-8">
                {plan.features.map((f, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-[#E5E5E5]">
                    <Check size={14} className="text-[#D4AF37] mt-0.5 flex-shrink-0" />{f}
                  </li>
                ))}
              </ul>
              <button
                onClick={() => handleSelect(plan.id)}
                disabled={loading === plan.id}
                className={`w-full py-3 font-bold uppercase tracking-wide text-sm rounded-sm transition-all disabled:opacity-50 ${
                  plan.highlight ? "bg-[#D4AF37] text-black hover:bg-[#C5A059]" : "bg-transparent border border-[#262626] text-white hover:border-[#D4AF37]"
                }`}
                data-testid={`select-plan-${plan.id}`}
              >
                {loading === plan.id ? "PROCESSING..." : <span className="flex items-center justify-center gap-2">GET STARTED <ArrowRight size={14} /></span>}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
